import Swal from 'sweetalert2';
import manager from "app/module46/component-manager.js";


manager.register('representative-requests', main);

/**
 * @param {Element} component
 * @param {Object.<string, Element>} references
 * @param {HTMLTemplateElement} references.callTemplateEl
 * @param {HTMLTemplateElement} references.historyTemplateEl
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function main(component, references, attributes, properties) {
	const SECOND = 1000;
	const MINUTE = SECOND * 60;
	const CALL_TIMEOUT = 5 * MINUTE;
	const refreshTimer = 2 * SECOND; // 2 seconds

	const {
		callTemplateEl,
		chatTemplateEl,
		callList,
		historyList,
	} = references;

	const {
		refreshUrl,
		createMessageUrl,
		modalContentUrl,
		acceptUrl,
		refuseUrl,
		callRefused,
		callText,
		noCallsText,
		timedOutText,
		timedOutUrl
	} = properties;

	let xhr, timeout;
	let callingRow = null;
	let callingStart = null;
	let chatTemplate = chatTemplateEl.innerHTML;
	let messageList = null;
	let data = {
		calling:         '',
		has_chat:        false,
		chat_id:         null,
		last_message_id: null,
		type:            null
	};

	function refreshData() {
		xhr = manager.api(refreshUrl, data, (res) => {
			const { incoming, callingResult, status, lines, lastMessageId } = res;

			if (data.calling !== '') {

				// See if subscriber answered
				if (callingResult !== null) {

					// If failure, show modal
					if (callingResult) {
						startCommunication(data.type, data.calling);
					} else {
						Swal.fire('', callRefused, 'warning');
					}

					const lastEl = callingRow.querySelector('.last');
					if (lastEl && status) {
						lastEl.innerHTML = status;
					}

					// if success or failure (not nothing), change url back
					data.calling = '';
					data.type = '';
					callingRow = null;

				} else if (Date.now() - callingStart >= CALL_TIMEOUT) {
					// If timed out
					let callingId = data.calling;

					// Short version of setCalling(false)
					data.calling = '';
					data.type = '';
					callingRow = null;

					// Mark call as timed out
					timedOut(callingId)
				}

			} else if (data.has_chat) {

				if (lastMessageId) {
					data.last_message_id = lastMessageId;
				}

				renderLines(lines);
			}

			if (incoming) {
				callList.innerHTML = '';

				if (Object.keys(incoming).length) {
					for (const request of incoming) {
						const row = parseRow(request, callTemplateEl, true);

						callList.appendChild(row);
					}
				} else {
					callList.innerHTML = `<tr><td colspan='4'>${noCallsText}</td></tr>`
				}
			}

			timeout = setTimeout(refreshData, refreshTimer);

		}, () => {
			timeout = setTimeout(refreshData, refreshTimer);
		});
	}

	/**
	 *
	 * @param rowData
	 * @param template
	 * @param addListener
	 * @return {Node|HTMLTableRowElement}
	 */
	function parseRow(rowData, template, addListener = false) {
		/** @typedef {HTMLTableRowElement} */
		let row = template.content.firstElementChild.cloneNode(true);

		for (const dataKey in rowData) {
			const el = row.querySelector(`.${dataKey}`);
			if (el) {
				el.innerHTML = rowData[dataKey];
			}
		}

		if (rowData.status === 'await_callback') {
			const alertZone = row.querySelector('.alert-zone');
			if (alertZone) {
				alertZone.style.display = 'none';
			}
		}

		if (addListener) {
			const confirmBtn = row.querySelector('.confirm-btn');

			if (confirmBtn) {
				confirmBtn.addEventListener('click', function () {
					const currRow = row.cloneNode(true);

					Swal.showLoading();

					// We check if the user is still calling at the same time that we accept the call to try to make sure that
					// We are showing the right action
					manager.get(`${acceptUrl}/${rowData.id}`, ({ callBack, newDateTime, status, type }) => {

						const dateTimeEl = currRow.querySelector('.datetime');
						if (dateTimeEl && newDateTime) {
							dateTimeEl.innerHTML = newDateTime;
						}

						const lastEl = currRow.querySelector('.last');
						if (lastEl && status) {
							lastEl.innerHTML = status;
						}

						historyList.prepend(currRow);

						if (callBack) {
							// Manage waiting for answer
							data.calling = rowData.id;
							data.type = type;
							callingRow = currRow;
							callingStart = Date.now();

							Swal.fire({
								text:              callText,
								type:              'warning',
								showConfirmButton: false,
								showCloseButton:   true,

								didOpen: () => {
									Swal.showLoading();
								}
							})
								.then(({ isDismissed }) => {

									if (isDismissed) {
										// Cancel call
										$.get(`${refuseUrl}/${rowData.id}`).then(({ newDateTime, status }) => {
											// Change status
											const dateTimeEl = currRow.querySelector('.datetime');
											if (dateTimeEl && newDateTime) {
												dateTimeEl.innerHTML = newDateTime;
											}

											const lastEl = currRow.querySelector('.last');
											if (lastEl && status) {
												lastEl.innerHTML = status;
											}

											// Revert variables
											data.calling = '';
											data.type = null;
											callingRow = null;

											forceRefresh();
										});
									}
								});
						} else {
							// Open modal with information (and chat if relevant)
							startCommunication(type, rowData.id);
						}

						forceRefresh();
					});
				});
			}
		}

		return row;
	}

	function forceRefresh() {
		xhr.abort();
		clearTimeout(timeout);
		refreshData();
	}

	/**
	 *
	 * @param hasChat
	 * @param id
	 */
	function setChat(hasChat = false, id = '') {
		data.has_chat = hasChat;
		data.chat_id = id;
		data.last_message_id = null;

		forceRefresh();
	}

	refreshData();

	function startCommunication(type, id) {
		Swal.showLoading();

		if (type === 'chat') {
			startChat(id);
		} else {
			startZoom(id);
		}
	}

	function startChat(id) {
		Swal.fire({
			html:              chatTemplate,
			showCloseButton:   true,
			showConfirmButton: false,
			allowEscapeKey:    false,
			allowEnterKey:     false,

			/** @param {HTMLElement} popup */
			willOpen: (popup) => {
				messageList = $('.chat__messages');
				const input = popup.querySelector('.chat__input');
				const submit = popup.querySelector('.chat__submit');

				submit.addEventListener('click', send);
				input.addEventListener('keyup', function (e) {
					if (e.keyCode === 13) {
						send();
					}
				});

				function send() {
					const val = input.value;

					if (!val) {
						return true;
					}

					input.value = '';

					manager.api(createMessageUrl, { id, val }, forceRefresh);
				}

				setChat(true, id)
			}

		}).then(() => {
			messageList = null;
			setChat();
		});
	}

	function startZoom(id) {
		// Get content and open modal
		manager.get(`${modalContentUrl}/${id}`, (html) => {
			Swal.fire({
				html,
				showCloseButton:   true,
				showConfirmButton: false,
			});
		})
	}

	function renderLines(lines) {
		if (messageList) {
			for (const linesKey in lines) {
				$(lines[linesKey]).prependTo(messageList);
			}
		}
	}

	function timedOut(id) {
		// Set call as refused on rep side since user has to be shown an accept refuse modal
		manager.get(`${timedOutUrl}/${id}`);
		Swal.fire('', timedOutText, 'warning');
	}
}
